export default "__VITE_ASSET__aa1480bb__"